import { trpc } from "@/lib/trpc";

/** Nome, foto e especialidades aparecem em vários lugares (agenda, equipe, pedidos) — tudo recarrega junto. */
export function useRecarregarPerfil() {
  const utils = trpc.useUtils();
  return () => {
    utils.me.current.invalidate();
    utils.me.resumo.invalidate();
    utils.organization.listDentists.invalidate();
    utils.team.list.invalidate();
  };
}
